const activationDialogConstantsAr = {
  userDeactivation: 'تعطيل حساب مستخدم',
  userActivation: 'تفعيل حساب مستخدم',
  userDeactivationContent:
    'أنت تحاول تعطيل هذا المستخدم في لوحة التحكم الإدارية ! سيتم رفض وصول تسجيل الدخول إلى لوحة التحكم الإدارية لهذا المستخدم، هل أنت متأكد ما زلت ترغب في القيام بهذا الإجراء؟',
  userActivationContent: 'أنت تحاول تفعيل هذا المستخدم.  هل أنت متأكد؟',
  deactivatePrompt: 'نعم, تعطيل',
  activatePrompt: 'نعم, تفعيل',
  cancel: 'إلغاء',
};

export default activationDialogConstantsAr;
